import e from "react";
function n(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var a,
  t = {
    exports: {}
  },
  o = {
    exports: {}
  },
  r = {};
var i,
  c,
  d,
  l,
  s,
  m,
  _,
  u,
  p,
  f,
  g,
  b,
  y,
  h,
  v = {};
/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
function x() {
  return c || (c = 1, "production" === process.env.NODE_ENV ? o.exports = function () {
    if (a) return r;
    a = 1;
    var e = "function" == typeof Symbol && Symbol.for,
      n = e ? Symbol.for("react.element") : 60103,
      t = e ? Symbol.for("react.portal") : 60106,
      o = e ? Symbol.for("react.fragment") : 60107,
      i = e ? Symbol.for("react.strict_mode") : 60108,
      c = e ? Symbol.for("react.profiler") : 60114,
      d = e ? Symbol.for("react.provider") : 60109,
      l = e ? Symbol.for("react.context") : 60110,
      s = e ? Symbol.for("react.async_mode") : 60111,
      m = e ? Symbol.for("react.concurrent_mode") : 60111,
      _ = e ? Symbol.for("react.forward_ref") : 60112,
      u = e ? Symbol.for("react.suspense") : 60113,
      p = e ? Symbol.for("react.suspense_list") : 60120,
      f = e ? Symbol.for("react.memo") : 60115,
      g = e ? Symbol.for("react.lazy") : 60116,
      b = e ? Symbol.for("react.block") : 60121,
      y = e ? Symbol.for("react.fundamental") : 60117,
      h = e ? Symbol.for("react.responder") : 60118,
      v = e ? Symbol.for("react.scope") : 60119;
    function x(e) {
      if ("object" == typeof e && null !== e) {
        var a = e.$$typeof;
        switch (a) {
          case n:
            switch (e = e.type) {
              case s:
              case m:
              case o:
              case c:
              case i:
              case u:
                return e;
              default:
                switch (e = e && e.$$typeof) {
                  case l:
                  case _:
                  case g:
                  case f:
                  case d:
                    return e;
                  default:
                    return a;
                }
            }
          case t:
            return a;
        }
      }
    }
    function G(e) {
      return x(e) === m;
    }
    return r.AsyncMode = s, r.ConcurrentMode = m, r.ContextConsumer = l, r.ContextProvider = d, r.Element = n, r.ForwardRef = _, r.Fragment = o, r.Lazy = g, r.Memo = f, r.Portal = t, r.Profiler = c, r.StrictMode = i, r.Suspense = u, r.isAsyncMode = function (e) {
      return G(e) || x(e) === s;
    }, r.isConcurrentMode = G, r.isContextConsumer = function (e) {
      return x(e) === l;
    }, r.isContextProvider = function (e) {
      return x(e) === d;
    }, r.isElement = function (e) {
      return "object" == typeof e && null !== e && e.$$typeof === n;
    }, r.isForwardRef = function (e) {
      return x(e) === _;
    }, r.isFragment = function (e) {
      return x(e) === o;
    }, r.isLazy = function (e) {
      return x(e) === g;
    }, r.isMemo = function (e) {
      return x(e) === f;
    }, r.isPortal = function (e) {
      return x(e) === t;
    }, r.isProfiler = function (e) {
      return x(e) === c;
    }, r.isStrictMode = function (e) {
      return x(e) === i;
    }, r.isSuspense = function (e) {
      return x(e) === u;
    }, r.isValidElementType = function (e) {
      return "string" == typeof e || "function" == typeof e || e === o || e === m || e === c || e === i || e === u || e === p || "object" == typeof e && null !== e && (e.$$typeof === g || e.$$typeof === f || e.$$typeof === d || e.$$typeof === l || e.$$typeof === _ || e.$$typeof === y || e.$$typeof === h || e.$$typeof === v || e.$$typeof === b);
    }, r.typeOf = x, r;
  }() : o.exports = (i || (i = 1, "production" !== process.env.NODE_ENV && function () {
    var e = "function" == typeof Symbol && Symbol.for,
      n = e ? Symbol.for("react.element") : 60103,
      a = e ? Symbol.for("react.portal") : 60106,
      t = e ? Symbol.for("react.fragment") : 60107,
      o = e ? Symbol.for("react.strict_mode") : 60108,
      r = e ? Symbol.for("react.profiler") : 60114,
      i = e ? Symbol.for("react.provider") : 60109,
      c = e ? Symbol.for("react.context") : 60110,
      d = e ? Symbol.for("react.async_mode") : 60111,
      l = e ? Symbol.for("react.concurrent_mode") : 60111,
      s = e ? Symbol.for("react.forward_ref") : 60112,
      m = e ? Symbol.for("react.suspense") : 60113,
      _ = e ? Symbol.for("react.suspense_list") : 60120,
      u = e ? Symbol.for("react.memo") : 60115,
      p = e ? Symbol.for("react.lazy") : 60116,
      f = e ? Symbol.for("react.block") : 60121,
      g = e ? Symbol.for("react.fundamental") : 60117,
      b = e ? Symbol.for("react.responder") : 60118,
      y = e ? Symbol.for("react.scope") : 60119;
    function h(e) {
      if ("object" == typeof e && null !== e) {
        var _ = e.$$typeof;
        switch (_) {
          case n:
            var f = e.type;
            switch (f) {
              case d:
              case l:
              case t:
              case r:
              case o:
              case m:
                return f;
              default:
                var g = f && f.$$typeof;
                switch (g) {
                  case c:
                  case s:
                  case p:
                  case u:
                  case i:
                    return g;
                  default:
                    return _;
                }
            }
          case a:
            return _;
        }
      }
    }
    var x = d,
      G = l,
      w = c,
      S = i,
      O = n,
      E = s,
      B = t,
      N = p,
      k = u,
      T = a,
      R = r,
      j = o,
      P = m,
      $ = !1;
    function C(e) {
      return h(e) === l;
    }
    v.AsyncMode = x, v.ConcurrentMode = G, v.ContextConsumer = w, v.ContextProvider = S, v.Element = O, v.ForwardRef = E, v.Fragment = B, v.Lazy = N, v.Memo = k, v.Portal = T, v.Profiler = R, v.StrictMode = j, v.Suspense = P, v.isAsyncMode = function (e) {
      return $ || ($ = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.")), C(e) || h(e) === d;
    }, v.isConcurrentMode = C, v.isContextConsumer = function (e) {
      return h(e) === c;
    }, v.isContextProvider = function (e) {
      return h(e) === i;
    }, v.isElement = function (e) {
      return "object" == typeof e && null !== e && e.$$typeof === n;
    }, v.isForwardRef = function (e) {
      return h(e) === s;
    }, v.isFragment = function (e) {
      return h(e) === t;
    }, v.isLazy = function (e) {
      return h(e) === p;
    }, v.isMemo = function (e) {
      return h(e) === u;
    }, v.isPortal = function (e) {
      return h(e) === a;
    }, v.isProfiler = function (e) {
      return h(e) === r;
    }, v.isStrictMode = function (e) {
      return h(e) === o;
    }, v.isSuspense = function (e) {
      return h(e) === m;
    }, v.isValidElementType = function (e) {
      return "string" == typeof e || "function" == typeof e || e === t || e === l || e === r || e === o || e === m || e === _ || "object" == typeof e && null !== e && (e.$$typeof === p || e.$$typeof === u || e.$$typeof === i || e.$$typeof === c || e.$$typeof === s || e.$$typeof === g || e.$$typeof === b || e.$$typeof === y || e.$$typeof === f);
    }, v.typeOf = h;
  }()), v)), o.exports;
}
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/
function G() {
  if (l) return d;
  l = 1;
  var e = Object.getOwnPropertySymbols,
    n = Object.prototype.hasOwnProperty,
    a = Object.prototype.propertyIsEnumerable;
  return d = function () {
    try {
      if (!Object.assign) return !1;
      var e = new String("abc");
      if (e[5] = "de", "5" === Object.getOwnPropertyNames(e)[0]) return !1;
      for (var n = {}, a = 0; a < 10; a++) n["_" + String.fromCharCode(a)] = a;
      if ("0123456789" !== Object.getOwnPropertyNames(n).map(function (e) {
        return n[e];
      }).join("")) return !1;
      var t = {};
      return "abcdefghijklmnopqrst".split("").forEach(function (e) {
        t[e] = e;
      }), "abcdefghijklmnopqrst" === Object.keys(Object.assign({}, t)).join("");
    } catch (e) {
      return !1;
    }
  }() ? Object.assign : function (t, o) {
    for (var r, i, c = function (e) {
        if (null == e) throw new TypeError("Object.assign cannot be called with null or undefined");
        return Object(e);
      }(t), d = 1; d < arguments.length; d++) {
      for (var l in r = Object(arguments[d])) n.call(r, l) && (c[l] = r[l]);
      if (e) {
        i = e(r);
        for (var s = 0; s < i.length; s++) a.call(r, i[s]) && (c[i[s]] = r[i[s]]);
      }
    }
    return c;
  }, d;
}
function w() {
  if (m) return s;
  m = 1;
  return s = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
}
function S() {
  return u ? _ : (u = 1, _ = Function.call.bind(Object.prototype.hasOwnProperty));
}
if ("production" !== process.env.NODE_ENV) {
  var O = x();
  t.exports = function () {
    if (b) return g;
    b = 1;
    var e = x(),
      n = G(),
      a = w(),
      t = S(),
      o = function () {
        if (f) return p;
        f = 1;
        var e = function e() {};
        if ("production" !== process.env.NODE_ENV) {
          var n = w(),
            a = {},
            t = S();
          e = function e(_e) {
            var n = "Warning: " + _e;
            "undefined" != typeof console && console.error(n);
            try {
              throw new Error(n);
            } catch (e) {}
          };
        }
        function o(o, r, i, c, d) {
          if ("production" !== process.env.NODE_ENV) for (var l in o) if (t(o, l)) {
            var s;
            try {
              if ("function" != typeof o[l]) {
                var m = Error((c || "React class") + ": " + i + " type `" + l + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof o[l] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw m.name = "Invariant Violation", m;
              }
              s = o[l](r, l, c, i, null, n);
            } catch (e) {
              s = e;
            }
            if (!s || s instanceof Error || e((c || "React class") + ": type specification of " + i + " `" + l + "` is invalid; the type checker function must return `null` or an `Error` but returned a " + typeof s + ". You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument)."), s instanceof Error && !(s.message in a)) {
              a[s.message] = !0;
              var _ = d ? d() : "";
              e("Failed " + i + " type: " + s.message + (null != _ ? _ : ""));
            }
          }
        }
        return o.resetWarningCache = function () {
          "production" !== process.env.NODE_ENV && (a = {});
        }, p = o;
      }(),
      r = function r() {};
    function i() {
      return null;
    }
    return "production" !== process.env.NODE_ENV && (r = function r(e) {
      var n = "Warning: " + e;
      "undefined" != typeof console && console.error(n);
      try {
        throw new Error(n);
      } catch (e) {}
    }), g = function g(c, d) {
      var l = "function" == typeof Symbol && Symbol.iterator,
        s = "<<anonymous>>",
        m = {
          array: f("array"),
          bigint: f("bigint"),
          bool: f("boolean"),
          func: f("function"),
          number: f("number"),
          object: f("object"),
          string: f("string"),
          symbol: f("symbol"),
          any: p(i),
          arrayOf: function arrayOf(e) {
            return p(function (n, t, o, r, i) {
              if ("function" != typeof e) return new u("Property `" + i + "` of component `" + o + "` has invalid PropType notation inside arrayOf.");
              var c = n[t];
              if (!Array.isArray(c)) return new u("Invalid " + r + " `" + i + "` of type `" + y(c) + "` supplied to `" + o + "`, expected an array.");
              for (var d = 0; d < c.length; d++) {
                var l = e(c, d, o, r, i + "[" + d + "]", a);
                if (l instanceof Error) return l;
              }
              return null;
            });
          },
          element: p(function (e, n, a, t, o) {
            var r = e[n];
            return c(r) ? null : new u("Invalid " + t + " `" + o + "` of type `" + y(r) + "` supplied to `" + a + "`, expected a single ReactElement.");
          }),
          elementType: p(function (n, a, t, o, r) {
            var i = n[a];
            return e.isValidElementType(i) ? null : new u("Invalid " + o + " `" + r + "` of type `" + y(i) + "` supplied to `" + t + "`, expected a single ReactElement type.");
          }),
          instanceOf: function instanceOf(e) {
            return p(function (n, a, t, o, r) {
              if (!(n[a] instanceof e)) {
                var i = e.name || s;
                return new u("Invalid " + o + " `" + r + "` of type `" + ((c = n[a]).constructor && c.constructor.name ? c.constructor.name : s) + "` supplied to `" + t + "`, expected instance of `" + i + "`.");
              }
              var c;
              return null;
            });
          },
          node: p(function (e, n, a, t, o) {
            return b(e[n]) ? null : new u("Invalid " + t + " `" + o + "` supplied to `" + a + "`, expected a ReactNode.");
          }),
          objectOf: function objectOf(e) {
            return p(function (n, o, r, i, c) {
              if ("function" != typeof e) return new u("Property `" + c + "` of component `" + r + "` has invalid PropType notation inside objectOf.");
              var d = n[o],
                l = y(d);
              if ("object" !== l) return new u("Invalid " + i + " `" + c + "` of type `" + l + "` supplied to `" + r + "`, expected an object.");
              for (var s in d) if (t(d, s)) {
                var m = e(d, s, r, i, c + "." + s, a);
                if (m instanceof Error) return m;
              }
              return null;
            });
          },
          oneOf: function oneOf(e) {
            return Array.isArray(e) ? p(function (n, a, t, o, r) {
              for (var i = n[a], c = 0; c < e.length; c++) if (_(i, e[c])) return null;
              var d = JSON.stringify(e, function (e, n) {
                return "symbol" === h(n) ? String(n) : n;
              });
              return new u("Invalid " + o + " `" + r + "` of value `" + String(i) + "` supplied to `" + t + "`, expected one of " + d + ".");
            }) : ("production" !== process.env.NODE_ENV && r(arguments.length > 1 ? "Invalid arguments supplied to oneOf, expected an array, got " + arguments.length + " arguments. A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z])." : "Invalid argument supplied to oneOf, expected an array."), i);
          },
          oneOfType: function oneOfType(e) {
            if (!Array.isArray(e)) return "production" !== process.env.NODE_ENV && r("Invalid argument supplied to oneOfType, expected an instance of array."), i;
            for (var n = 0; n < e.length; n++) {
              var o = e[n];
              if ("function" != typeof o) return r("Invalid argument supplied to oneOfType. Expected an array of check functions, but received " + v(o) + " at index " + n + "."), i;
            }
            return p(function (n, o, r, i, c) {
              for (var d = [], l = 0; l < e.length; l++) {
                var s = (0, e[l])(n, o, r, i, c, a);
                if (null == s) return null;
                s.data && t(s.data, "expectedType") && d.push(s.data.expectedType);
              }
              return new u("Invalid " + i + " `" + c + "` supplied to `" + r + "`" + (d.length > 0 ? ", expected one of type [" + d.join(", ") + "]" : "") + ".");
            });
          },
          shape: function shape(e) {
            return p(function (n, t, o, r, i) {
              var c = n[t],
                d = y(c);
              if ("object" !== d) return new u("Invalid " + r + " `" + i + "` of type `" + d + "` supplied to `" + o + "`, expected `object`.");
              for (var l in e) {
                var s = e[l];
                if ("function" != typeof s) return g(o, r, i, l, h(s));
                var m = s(c, l, o, r, i + "." + l, a);
                if (m) return m;
              }
              return null;
            });
          },
          exact: function exact(e) {
            return p(function (o, r, i, c, d) {
              var l = o[r],
                s = y(l);
              if ("object" !== s) return new u("Invalid " + c + " `" + d + "` of type `" + s + "` supplied to `" + i + "`, expected `object`.");
              var m = n({}, o[r], e);
              for (var _ in m) {
                var p = e[_];
                if (t(e, _) && "function" != typeof p) return g(i, c, d, _, h(p));
                if (!p) return new u("Invalid " + c + " `" + d + "` key `" + _ + "` supplied to `" + i + "`.\nBad object: " + JSON.stringify(o[r], null, "  ") + "\nValid keys: " + JSON.stringify(Object.keys(e), null, "  "));
                var f = p(l, _, i, c, d + "." + _, a);
                if (f) return f;
              }
              return null;
            });
          }
        };
      function _(e, n) {
        return e === n ? 0 !== e || 1 / e == 1 / n : e != e && n != n;
      }
      function u(e, n) {
        this.message = e, this.data = n && "object" == typeof n ? n : {}, this.stack = "";
      }
      function p(e) {
        if ("production" !== process.env.NODE_ENV) var n = {},
          t = 0;
        function o(o, i, c, l, m, _, p) {
          if (l = l || s, _ = _ || c, p !== a) {
            if (d) {
              var f = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use `PropTypes.checkPropTypes()` to call them. Read more at http://fb.me/use-check-prop-types");
              throw f.name = "Invariant Violation", f;
            }
            if ("production" !== process.env.NODE_ENV && "undefined" != typeof console) {
              var g = l + ":" + c;
              !n[g] && t < 3 && (r("You are manually calling a React.PropTypes validation function for the `" + _ + "` prop on `" + l + "`. This is deprecated and will throw in the standalone `prop-types` package. You may be seeing this warning due to a third-party PropTypes library. See https://fb.me/react-warning-dont-call-proptypes for details."), n[g] = !0, t++);
            }
          }
          return null == i[c] ? o ? null === i[c] ? new u("The " + m + " `" + _ + "` is marked as required in `" + l + "`, but its value is `null`.") : new u("The " + m + " `" + _ + "` is marked as required in `" + l + "`, but its value is `undefined`.") : null : e(i, c, l, m, _);
        }
        var i = o.bind(null, !1);
        return i.isRequired = o.bind(null, !0), i;
      }
      function f(e) {
        return p(function (n, a, t, o, r, i) {
          var c = n[a];
          return y(c) !== e ? new u("Invalid " + o + " `" + r + "` of type `" + h(c) + "` supplied to `" + t + "`, expected `" + e + "`.", {
            expectedType: e
          }) : null;
        });
      }
      function g(e, n, a, t, o) {
        return new u((e || "React class") + ": " + n + " type `" + a + "." + t + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + o + "`.");
      }
      function b(e) {
        switch (typeof e) {
          case "number":
          case "string":
          case "undefined":
            return !0;
          case "boolean":
            return !e;
          case "object":
            if (Array.isArray(e)) return e.every(b);
            if (null === e || c(e)) return !0;
            var n = function (e) {
              var n = e && (l && e[l] || e["@@iterator"]);
              if ("function" == typeof n) return n;
            }(e);
            if (!n) return !1;
            var a,
              t = n.call(e);
            if (n !== e.entries) {
              for (; !(a = t.next()).done;) if (!b(a.value)) return !1;
            } else for (; !(a = t.next()).done;) {
              var o = a.value;
              if (o && !b(o[1])) return !1;
            }
            return !0;
          default:
            return !1;
        }
      }
      function y(e) {
        var n = typeof e;
        return Array.isArray(e) ? "array" : e instanceof RegExp ? "object" : function (e, n) {
          return "symbol" === e || !!n && ("Symbol" === n["@@toStringTag"] || "function" == typeof Symbol && n instanceof Symbol);
        }(n, e) ? "symbol" : n;
      }
      function h(e) {
        if (null == e) return "" + e;
        var n = y(e);
        if ("object" === n) {
          if (e instanceof Date) return "date";
          if (e instanceof RegExp) return "regexp";
        }
        return n;
      }
      function v(e) {
        var n = h(e);
        switch (n) {
          case "array":
          case "object":
            return "an " + n;
          case "boolean":
          case "date":
          case "regexp":
            return "a " + n;
          default:
            return n;
        }
      }
      return u.prototype = Error.prototype, m.checkPropTypes = o, m.resetWarningCache = o.resetWarningCache, m.PropTypes = m, m;
    }, g;
  }()(O.isElement, !0);
} else t.exports = function () {
  if (h) return y;
  h = 1;
  var e = w();
  function n() {}
  function a() {}
  return a.resetWarningCache = n, y = function y() {
    function t(n, a, t, o, r, i) {
      if (i !== e) {
        var c = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
        throw c.name = "Invariant Violation", c;
      }
    }
    function o() {
      return t;
    }
    t.isRequired = t;
    var r = {
      array: t,
      bigint: t,
      bool: t,
      func: t,
      number: t,
      object: t,
      string: t,
      symbol: t,
      any: t,
      arrayOf: o,
      element: t,
      elementType: t,
      instanceOf: o,
      node: t,
      objectOf: o,
      oneOf: o,
      oneOfType: o,
      shape: o,
      exact: o,
      checkPropTypes: a,
      resetWarningCache: n
    };
    return r.PropTypes = r, r;
  };
}()();
var E = n(t.exports);
function B(e, n) {
  void 0 === n && (n = {});
  var a = n.insertAt;
  if (e && "undefined" != typeof document) {
    var t = document.head || document.getElementsByTagName("head")[0],
      o = document.createElement("style");
    o.type = "text/css", "top" === a && t.firstChild ? t.insertBefore(o, t.firstChild) : t.appendChild(o), o.styleSheet ? o.styleSheet.cssText = e : o.appendChild(document.createTextNode(e));
  }
}
var N = {
  wrapper: "Gamecard-module_wrapper__f3a4i",
  hoverable: "Gamecard-module_hoverable__Vo-Ri",
  game_link: "Gamecard-module_game_link__pl08C",
  card__container: "Gamecard-module_card__container__mWJOC",
  with_footer: "Gamecard-module_with_footer__AJIhA",
  logos__container: "Gamecard-module_logos__container__u5A-Y",
  logo: "Gamecard-module_logo__tSlC4",
  teams__container: "Gamecard-module_teams__container__0iQ7-",
  team_name: "Gamecard-module_team_name__2gmOw",
  team_name__ghost: "Gamecard-module_team_name__ghost__-w7xm",
  loser: "Gamecard-module_loser__ff4HX",
  posession_indicator: "Gamecard-module_posession_indicator__46aug",
  visiting: "Gamecard-module_visiting__s4nSp",
  home: "Gamecard-module_home__PRf3K",
  hide: "Gamecard-module_hide__HYpPa",
  powerplay_indicator: "Gamecard-module_powerplay_indicator__HqBad",
  data__container: "Gamecard-module_data__container__OTYDa",
  team_data: "Gamecard-module_team_data__OBnJb",
  score: "Gamecard-module_score__wX6l9",
  odds: "Gamecard-module_odds__0dGQ8",
  team_data__ghost: "Gamecard-module_team_data__ghost__V5J5f",
  status__container: "Gamecard-module_status__container__orgo4",
  game_status__ghost: "Gamecard-module_game_status__ghost__zNwbB",
  footer__container: "Gamecard-module_footer__container__iFz0o"
};
B('.Gamecard-module_wrapper__f3a4i {\n  transition: background-color 0.2s, border 0.2s, box-shadow 0.2s;\n  border: 1px solid #cecece;\n  border-radius: 8px;\n}\n.Gamecard-module_wrapper__f3a4i.Gamecard-module_hoverable__Vo-Ri:hover {\n  background-color: #f5f9fc;\n  border: 1px solid #005eb8;\n  box-shadow: inset 0px 0px 0px 1px #005eb8;\n  cursor: pointer;\n}\n\n.Gamecard-module_game_link__pl08C {\n  text-decoration: none;\n}\n.Gamecard-module_game_link__pl08C:hover {\n  text-decoration: none;\n}\n\n.Gamecard-module_card__container__mWJOC {\n  display: flex;\n  flex: 1;\n  flex-direction: row;\n  flex-wrap: nowrap;\n  padding: 8px;\n  text-decoration: none;\n}\n.Gamecard-module_card__container__mWJOC.Gamecard-module_with_footer__AJIhA {\n  border-bottom-left-radius: 0px;\n  border-bottom-right-radius: 0px;\n  border-bottom: 0px;\n}\n\n.Gamecard-module_logos__container__u5A-Y {\n  display: flex;\n  flex-direction: column;\n}\n.Gamecard-module_logos__container__u5A-Y .Gamecard-module_logo__tSlC4 {\n  height: 24px;\n  width: 24px;\n  margin-right: 8px;\n}\n.Gamecard-module_logos__container__u5A-Y .Gamecard-module_logo__tSlC4:first-of-type {\n  margin-bottom: 8px;\n}\n\n.Gamecard-module_teams__container__0iQ7- {\n  display: flex;\n  flex: 2;\n  flex-direction: column;\n  min-width: 0px;\n}\n.Gamecard-module_teams__container__0iQ7- .Gamecard-module_team_name__2gmOw {\n  font-family: "protipo-narrow";\n  font-size: 16px;\n  line-height: 24px;\n  font-weight: bold;\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n  min-width: 0px;\n}\n.Gamecard-module_teams__container__0iQ7- .Gamecard-module_team_name__2gmOw:first-of-type {\n  margin-bottom: 8px;\n}\n.Gamecard-module_teams__container__0iQ7- .Gamecard-module_team_name__ghost__-w7xm {\n  margin-top: 3px;\n}\n.Gamecard-module_teams__container__0iQ7- .Gamecard-module_team_name__ghost__-w7xm:last-of-type {\n  margin-top: 15px;\n}\n.Gamecard-module_teams__container__0iQ7- .Gamecard-module_loser__ff4HX {\n  font-weight: 500;\n  color: #5b6770;\n}\n\n.Gamecard-module_posession_indicator__46aug {\n  border-radius: 75% 15%;\n  transform: rotate(45deg);\n  width: 10px;\n  height: 10px;\n  background-color: #5b676f;\n  margin-right: 12px;\n  opacity: 1;\n  margin-top: 6px;\n  transition: margin 0.2s cubic-bezier(0.24, 1.13, 0.65, 1.21), opacity 0.2s 0.2s;\n}\n.Gamecard-module_posession_indicator__46aug.Gamecard-module_visiting__s4nSp {\n  margin-top: 6px;\n}\n.Gamecard-module_posession_indicator__46aug.Gamecard-module_home__PRf3K {\n  margin-top: 38px;\n}\n.Gamecard-module_posession_indicator__46aug.Gamecard-module_hide__HYpPa {\n  opacity: 0;\n  margin-top: 16px;\n  transition: margin 0.2s 0.2s cubic-bezier(0.24, 1.13, 0.65, 1.21), opacity 0.2s;\n}\n\n.Gamecard-module_powerplay_indicator__HqBad {\n  background-color: #515c64;\n  color: #fff;\n  width: 22px;\n  height: 18px;\n  font-family: "protipo-narrow";\n  font-size: 12px;\n  line-height: 12px;\n  font-weight: bold;\n  border-radius: 2px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  margin-right: 12px;\n  opacity: 1;\n  margin-top: 3px;\n  transition: margin 0.2s cubic-bezier(0.24, 1.13, 0.65, 1.21), opacity 0.2s 0.2s;\n}\n.Gamecard-module_powerplay_indicator__HqBad.Gamecard-module_visiting__s4nSp {\n  margin-top: 3px;\n}\n.Gamecard-module_powerplay_indicator__HqBad.Gamecard-module_home__PRf3K {\n  margin-top: 35px;\n}\n.Gamecard-module_powerplay_indicator__HqBad.Gamecard-module_hide__HYpPa {\n  opacity: 0;\n  margin-top: 16px;\n  transition: margin 0.2s 0.2s cubic-bezier(0.24, 1.13, 0.65, 1.21), opacity 0.2s;\n}\n\n.Gamecard-module_data__container__OTYDa {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-end;\n  padding: 0 16px 0 4px;\n}\n.Gamecard-module_data__container__OTYDa .Gamecard-module_team_data__OBnJb {\n  font-family: "protipo-narrow";\n  font-size: 16px;\n  line-height: 24px;\n  white-space: nowrap;\n}\n.Gamecard-module_data__container__OTYDa .Gamecard-module_team_data__OBnJb.Gamecard-module_score__wX6l9 {\n  font-weight: bold;\n}\n.Gamecard-module_data__container__OTYDa .Gamecard-module_team_data__OBnJb.Gamecard-module_odds__0dGQ8 {\n  font-size: 14px;\n  line-height: 24px;\n}\n.Gamecard-module_data__container__OTYDa .Gamecard-module_team_data__OBnJb:first-of-type {\n  margin-bottom: 8px;\n}\n.Gamecard-module_data__container__OTYDa .Gamecard-module_loser__ff4HX {\n  font-weight: 500 !important;\n  color: #5b6770;\n}\n.Gamecard-module_data__container__OTYDa .Gamecard-module_team_data__ghost__V5J5f {\n  margin-top: 4px;\n}\n.Gamecard-module_data__container__OTYDa .Gamecard-module_team_data__ghost__V5J5f:last-of-type {\n  margin-top: 17px;\n}\n\n.Gamecard-module_status__container__orgo4 {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  flex-basis: 76px;\n  margin-left: auto;\n  padding: 0 8px;\n  font-family: "protipo-narrow";\n  font-size: 14px;\n  line-height: 18px;\n  text-align: right;\n}\n.Gamecard-module_status__container__orgo4 .Gamecard-module_game_status__ghost__zNwbB {\n  margin-left: auto;\n}\n\n.Gamecard-module_footer__container__iFz0o {\n  padding: 4px;\n  text-align: center;\n  font-family: "protipo-narrow";\n  font-style: italic;\n  font-size: 14px;\n  font-weight: 500;\n  line-height: 14px;\n  border-radius: 0px 0px 8px 8px;\n  background-color: #005eb8;\n  color: white;\n}\n\n@media (prefers-color-scheme: dark) {\n  .Gamecard-module_wrapper__f3a4i {\n    background: #1d2f43;\n  }\n  .Gamecard-module_wrapper__f3a4i.Gamecard-module_hoverable__Vo-Ri:hover .Gamecard-module_team_name__2gmOw {\n    color: #000;\n  }\n  .Gamecard-module_wrapper__f3a4i.Gamecard-module_hoverable__Vo-Ri:hover .Gamecard-module_team_data__OBnJb .Gamecard-module_odds__0dGQ8 {\n    color: #636a71;\n  }\n  .Gamecard-module_wrapper__f3a4i.Gamecard-module_hoverable__Vo-Ri:hover .Gamecard-module_team_data__OBnJb,\n  .Gamecard-module_wrapper__f3a4i.Gamecard-module_hoverable__Vo-Ri:hover .Gamecard-module_status__container__orgo4 {\n    color: #343434;\n  }\n  .Gamecard-module_team_data__OBnJb .Gamecard-module_odds__0dGQ8 {\n    color: #fff;\n  }\n  .Gamecard-module_team_name__2gmOw,\n  .Gamecard-module_team_data__OBnJb,\n  .Gamecard-module_status__container__orgo4 {\n    color: #fff;\n  }\n}\n.darkMode .Gamecard-module_wrapper__f3a4i {\n  background: #1d2f43;\n}\n.darkMode .Gamecard-module_wrapper__f3a4i.Gamecard-module_hoverable__Vo-Ri:hover .Gamecard-module_team_name__2gmOw {\n  color: #000;\n}\n.darkMode .Gamecard-module_wrapper__f3a4i.Gamecard-module_hoverable__Vo-Ri:hover .Gamecard-module_team_data__OBnJb .Gamecard-module_odds__0dGQ8 {\n  color: #636a71;\n}\n.darkMode .Gamecard-module_wrapper__f3a4i.Gamecard-module_hoverable__Vo-Ri:hover .Gamecard-module_team_data__OBnJb,\n.darkMode .Gamecard-module_wrapper__f3a4i.Gamecard-module_hoverable__Vo-Ri:hover .Gamecard-module_status__container__orgo4 {\n  color: #343434;\n}\n.darkMode .Gamecard-module_team_data__OBnJb .Gamecard-module_odds__0dGQ8 {\n  color: #fff;\n}\n.darkMode .Gamecard-module_team_name__2gmOw,\n.darkMode .Gamecard-module_team_data__OBnJb,\n.darkMode .Gamecard-module_status__container__orgo4 {\n  color: #fff;\n}\n\n@media (prefers-color-scheme: light) {\n  .Gamecard-module_wrapper__f3a4i {\n    background: #fff;\n  }\n  .Gamecard-module_team_name__2gmOw {\n    color: #000;\n  }\n  .Gamecard-module_team_data__OBnJb .Gamecard-module_odds__0dGQ8 {\n    color: #636a71;\n  }\n  .Gamecard-module_team_data__OBnJb,\n  .Gamecard-module_status__container__orgo4 {\n    color: #343434;\n  }\n}\n.lightMode .Gamecard-module_wrapper__f3a4i {\n  background: #fff;\n}\n.lightMode .Gamecard-module_team_name__2gmOw {\n  color: #000;\n}\n.lightMode .Gamecard-module_team_data__OBnJb .Gamecard-module_odds__0dGQ8 {\n  color: #636a71;\n}\n.lightMode .Gamecard-module_team_data__OBnJb,\n.lightMode .Gamecard-module_status__container__orgo4 {\n  color: #343434;\n}');
var k = {
  LoadingSkeleton__cont: "LoadingSkeleton-module_LoadingSkeleton__cont__voTNN",
  LoadingSkeleton__animated: "LoadingSkeleton-module_LoadingSkeleton__animated__wxmIl",
  shine: "LoadingSkeleton-module_shine__x0Cxs",
  grey: "LoadingSkeleton-module_grey__0i2c3",
  snBlue: "LoadingSkeleton-module_snBlue__Rn0Ew"
};
function T() {
  for (var e = arguments.length, n = new Array(e), a = 0; a < e; a++) n[a] = arguments[a];
  return n.filter(Boolean).join(" ");
}
B(".LoadingSkeleton-module_LoadingSkeleton__cont__voTNN {\n    background-color: #ddd;\n}\n\n.LoadingSkeleton-module_LoadingSkeleton__animated__wxmIl {\n    background: linear-gradient(110deg, #ececec 8%, #f5f5f5 18%, #ececec 33%);\n    border-radius: 5px;\n    background-size: 400% 100%;\n    animation-name: LoadingSkeleton-module_shine__x0Cxs;\n    animation-duration: 3s;\n    animation-iteration-count: infinite;\n    animation-timing-function: linear;\n\n    &.LoadingSkeleton-module_grey__0i2c3 {\n        background: linear-gradient(110deg, #ececec 8%, #f5f5f5 18%, #ececec 33%);\n        background-size: 400% 100%;\n    }\n    &.LoadingSkeleton-module_snBlue__Rn0Ew {\n        background: linear-gradient(110deg, #156bac 8%, #156bac99 18%, #156bac 33%);\n        background-size: 400% 100%;\n    }\n}\n\n@keyframes LoadingSkeleton-module_shine__x0Cxs {\n    to {\n        background-position-x: -400%;\n    }\n}\n");
var R = function R(n) {
  var a = n.width,
    t = n.height,
    o = n.aspectRatio,
    r = n.opacity,
    i = n.round,
    c = n.animate,
    d = n.borderRadius,
    l = n.marginTop,
    s = n.color;
  return e.createElement("div", {
    className: T(k.LoadingSkeleton__cont, c ? k.LoadingSkeleton__animated : "", k[s]),
    style: {
      width: a,
      height: t,
      aspectRatio: o,
      marginTop: l,
      opacity: r,
      borderRadius: i ? "50%" : d
    }
  });
};
R.propTypes = {
  width: E.oneOfType([E.number, E.string]),
  height: E.oneOfType([E.number, E.string]),
  round: E.bool,
  animate: E.bool,
  borderRadius: E.number,
  color: E.oneOf(["grey", "snBlue"])
}, R.defaultProps = {
  width: 32,
  height: 12,
  round: !1,
  animate: !0,
  borderRadius: 0,
  color: "grey"
};
var j = "BaseballGameStatus-module_wrapper__0Gu8R",
  P = "BaseballGameStatus-module_bases__container__d-oR-",
  $ = "BaseballGameStatus-module_base__neezM",
  C = "BaseballGameStatus-module_first__NztZf",
  M = "BaseballGameStatus-module_second__VNPAf",
  z = "BaseballGameStatus-module_third__l-Mn1",
  I = "BaseballGameStatus-module_occupied__nWrBI",
  V = "BaseballGameStatus-module_outs__container__zjQxH",
  A = "BaseballGameStatus-module_out_indicator__mH-Hw",
  L = "BaseballGameStatus-module_out__w-Ee-",
  D = "BaseballGameStatus-module_inning__container__YrhRI",
  J = "BaseballGameStatus-module_inning_portion_indicator__7LHjR",
  H = "BaseballGameStatus-module_bottom__hics7",
  Y = "BaseballGameStatus-module_inning_indicator_text__4QAon";
B('.BaseballGameStatus-module_wrapper__0Gu8R {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  margin-left: auto;\n}\n\n.BaseballGameStatus-module_bases__container__d-oR- {\n  position: relative;\n  height: 24px;\n  width: 32px;\n}\n\n.BaseballGameStatus-module_base__neezM {\n  width: 10px;\n  height: 10px;\n  border: 1px solid #636a71;\n  transform: rotate(45deg);\n  background-color: transparent;\n  box-sizing: content-box;\n  position: absolute;\n  transition: background-color 0.2s ease-in-out;\n}\n.BaseballGameStatus-module_base__neezM.BaseballGameStatus-module_first__NztZf {\n  top: 10px;\n  right: 0px;\n}\n.BaseballGameStatus-module_base__neezM.BaseballGameStatus-module_second__VNPAf {\n  left: 10px;\n}\n.BaseballGameStatus-module_base__neezM.BaseballGameStatus-module_third__l-Mn1 {\n  top: 10px;\n  left: 0px;\n}\n.BaseballGameStatus-module_base__neezM.BaseballGameStatus-module_occupied__nWrBI {\n  background-color: #636a71;\n}\n\n.BaseballGameStatus-module_outs__container__zjQxH {\n  width: 34px;\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  padding-top: 5px;\n}\n.BaseballGameStatus-module_outs__container__zjQxH .BaseballGameStatus-module_out_indicator__mH-Hw {\n  width: 6px;\n  height: 6px;\n  border-radius: 50%;\n  box-sizing: content-box;\n  border: 1px solid #636a71;\n  transition: background-color 0.2s ease-in-out;\n}\n.BaseballGameStatus-module_outs__container__zjQxH .BaseballGameStatus-module_out_indicator__mH-Hw.BaseballGameStatus-module_out__w-Ee- {\n  background-color: #636a71;\n}\n\n.BaseballGameStatus-module_inning__container__YrhRI {\n  display: flex;\n  flex-direction: row;\n  padding-top: 3px;\n  width: 34px;\n  justify-content: center;\n  align-items: center;\n}\n.BaseballGameStatus-module_inning__container__YrhRI .BaseballGameStatus-module_inning_portion_indicator__7LHjR {\n  width: 0;\n  height: 0;\n  margin-right: 2px;\n  border-left: 5px solid transparent;\n  border-right: 5px solid transparent;\n  border-bottom: 8px solid #636a71;\n  transition: transform 0.8s ease-in-out;\n  transform: rotate(0deg);\n}\n.BaseballGameStatus-module_inning__container__YrhRI .BaseballGameStatus-module_inning_portion_indicator__7LHjR.BaseballGameStatus-module_bottom__hics7 {\n  transform: rotate(180deg);\n}\n.BaseballGameStatus-module_inning__container__YrhRI .BaseballGameStatus-module_inning_indicator_text__4QAon {\n  font-family: "protipo-narrow";\n  font-size: 14px;\n  line-height: 16px;\n}');
var Q = function Q(n) {
    var a,
      t,
      o,
      r = n.firstBaseOccupied,
      i = n.secondBaseOccupied,
      c = n.thirdBaseOccupied,
      d = n.outs,
      l = n.inningNumber,
      s = n.inningPortion;
    return e.createElement("div", {
      className: j
    }, e.createElement("div", {
      className: P
    }, e.createElement("div", {
      className: "".concat($, " ").concat(C, " ").concat(r && I)
    }), e.createElement("div", {
      className: "".concat($, " ").concat(M, " ").concat(i && I)
    }), e.createElement("div", {
      className: "".concat($, " ").concat(z, " ").concat(c && I)
    })), e.createElement("div", {
      className: V
    }, e.createElement("div", {
      className: "".concat(A, " ").concat(d >= 1 && L)
    }), e.createElement("div", {
      className: "".concat(A, " ").concat(d >= 2 && L)
    }), e.createElement("div", {
      className: "".concat(A, " ").concat(d >= 3 && L)
    })), e.createElement("div", {
      className: D
    }, ("top" === s || "bot" === s) && e.createElement(e.Fragment, null, e.createElement("div", {
      className: "".concat(J, " ").concat("bot" === s && H)
    }), e.createElement("div", {
      className: Y
    }, (o = (a = l) % 100, 1 === (t = a % 10) && 11 !== o ? a + "st" : 2 === t && 12 !== o ? a + "nd" : 3 === t && 13 !== o ? a + "rd" : a + "th"))), ("mid" === s || "end" === s) && e.createElement(e.Fragment, null, e.createElement("div", {
      className: Y
    }, s.toUpperCase(), " "), e.createElement("div", {
      className: Y
    }, l))));
  },
  F = function F(n) {
    var a = n.visitingTeamName,
      t = n.visitingTeamLogo,
      o = n.homeTeamName,
      r = n.homeTeamLogo,
      i = n.visitingTeamData,
      c = n.homeTeamData,
      d = n.teamDataStyle,
      l = n.renderGameStatus,
      s = n.footerText,
      m = n.posession,
      _ = n.powerplay,
      u = n.isBaseball,
      p = n.firstBaseOccupied,
      f = n.secondBaseOccupied,
      g = n.thirdBaseOccupied,
      b = n.outs,
      y = n.inningNumber,
      h = n.inningPortion,
      v = n.link,
      x = n.loser,
      G = n.forceColorScheme,
      w = n.onBlur,
      S = n.isArrowFocused,
      O = !!s;
    return u && (l = function l() {
      return e.createElement(Q, {
        firstBaseOccupied: p,
        secondBaseOccupied: f,
        thirdBaseOccupied: g,
        outs: b,
        inningNumber: y,
        inningPortion: h
      });
    }), e.createElement("a", {
      href: v,
      className: T(N.game_link, G),
      onBlur: w,
      tabIndex: S ? -1 : 0
    }, e.createElement("div", {
      className: "".concat(N.wrapper, " ").concat(v ? N.hoverable : "")
    }, e.createElement("div", {
      className: "".concat(N.card__container, " ").concat(O ? N.with_footer : "")
    }, e.createElement("div", {
      className: N.logos__container
    }, t ? e.createElement("img", {
      className: N.logo,
      src: t,
      alt: "Visiting team logo",
      onError: function onError(e) {
        return e.target.src = "https://d16neqptz2ajf.cloudfront.net/tbd.svg";
      }
    }) : e.createElement("div", {
      className: N.logo
    }, e.createElement(R, {
      round: !0,
      width: 24,
      height: 24
    })), r ? e.createElement("img", {
      className: N.logo,
      src: r,
      alt: "Home team logo",
      onError: function onError(e) {
        return e.target.src = "https://d16neqptz2ajf.cloudfront.net/tbd.svg";
      }
    }) : e.createElement("div", {
      className: N.logo
    }, e.createElement(R, {
      round: !0,
      width: 24,
      height: 24
    }))), e.createElement("div", {
      className: N.teams__container
    }, a ? e.createElement("div", {
      className: "\n                                ".concat(N.team_name, " \n                                ").concat("visiting" === x ? N.loser : null, "\n                            ")
    }, a) : e.createElement("div", {
      className: N.team_name__ghost
    }, e.createElement(R, {
      borderRadius: 4,
      width: 100,
      height: 18
    })), o ? e.createElement("div", {
      className: "\n                                    ".concat(N.team_name, " \n                                    ").concat("home" === x ? N.loser : null, "\n                                ")
    }, o) : e.createElement("div", {
      className: N.team_name__ghost
    }, e.createElement(R, {
      borderRadius: 4,
      width: 82,
      height: 18
    }))), m && e.createElement("div", {
      className: "".concat(N.posession_indicator, " ").concat(N[m])
    }), _ && e.createElement("div", {
      className: "".concat(N.powerplay_indicator, " ").concat(N[_])
    }, "PP"), e.createElement("div", {
      className: N.data__container
    }, i ? e.createElement("div", {
      className: "\n                                ".concat(N.team_data, " \n                                ").concat(N[d], "\n                                ").concat("visiting" === x ? N.loser : null, "\n                            ")
    }, i) : e.createElement("div", {
      className: N.team_data__ghost
    }, e.createElement(R, {
      borderRadius: 4,
      width: 30,
      height: 16
    })), c ? e.createElement("div", {
      className: "\n                                ".concat(N.team_data, " \n                                ").concat(N[d], "\n                                ").concat("home" === x ? N.loser : null, "\n                            ")
    }, c) : e.createElement("div", {
      className: N.team_data__ghost
    }, e.createElement(R, {
      borderRadius: 4,
      width: 40,
      height: 16
    }))), e.createElement("div", {
      className: N.status__container
    }, l && l(), !l && e.createElement("div", {
      className: N.game_status__ghost
    }, e.createElement(R, {
      borderRadius: 4,
      width: 60,
      height: 34
    })))), O && e.createElement("div", {
      className: N.footer__container
    }, s)));
  };
F.propTypes = {
  forceColorScheme: E.oneOf(["darkMode", "lightMode", "system"]).isRequired,
  visitingTeamName: E.string,
  visitingTeamLogo: E.string,
  homeTeamName: E.string,
  homeTeamLogo: E.string,
  visitingTeamData: E.string,
  homeTeamData: E.string,
  teamDataStyle: E.oneOf(["score", "odds"]),
  renderGameStatus: E.func,
  footerText: E.string,
  posession: E.oneOf(["visiting", "home", "hide"]),
  powerplay: E.oneOf(["visiting", "home", "hide"]),
  isBaseball: E.bool,
  firstBaseOccupied: E.bool,
  secondBaseOccupied: E.bool,
  thirdBaseOccupied: E.bool,
  outs: E.number,
  inningNumber: E.number,
  inningPortion: E.oneOf(["top", "bot", "mid", "end"]),
  link: E.string,
  loser: E.oneOf(["visiting", "home"])
}, F.defaultProps = {
  teamDataStyle: "score",
  forceColorScheme: "lightMode"
};
export { F as Gamecard, F as default };